import React from 'react';
import OrderHistoryContainer from '../../../Componant/Ecommerce/OrderHistory';

const OrderHistory = () => {
  return (
    <div className='page-body'>
      <OrderHistoryContainer />
    </div>
  );
};

export default OrderHistory;
